module.exports = __webpack_public_path__ + "img/xrc2.c22b2ec2.png";